import ListCity from "../../containers/City/List";
import EntryCity from "../../containers/City";
import ListCountry from "../../containers/Country/List";
import EntryCountry from "../../containers/Country";

const cityCountryRoutes = [
  {
    path: "/cities",
    exact: true,
    auth: true,
    component: ListCity
  },
  {
    path: "/cities/:type",
    exact: true,
    auth: true,
    component: EntryCity
  },
  {
    path: "/cities/:type/:id",
    exact: true,
    auth: true,
    component: EntryCity
  },
  {
    path: "/countries",
    exact: true,
    auth: true,
    component: ListCountry
  },
  {
    path: "/countries/:type",
    exact: true,
    auth: true,
    component: EntryCountry
  },
  {
    path: "/countries/:type/:id",
    exact: true,
    auth: true,
    component: EntryCountry
  }
];

export default cityCountryRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/cities&countries.jsx